import { Injectable } from '@angular/core'
import { BaseProviderStatus, BaseShippingProviderService, ProviderStatusEntry } from '../shared/base-shipping-provider.service'

export interface AymakanSettings {
  enabled: boolean
  apiKey: string
  originCountryCode: string
  originCityName: string
  originAddressLine: string
  originPhone: string
  flatRate: number | null
  baseRate: number | null
  perKgRate: number | null
}

export interface AymakanSettingsStatus extends BaseProviderStatus {
  originCountryCode?: string
  originCityName?: string
  originAddressLine?: string
  originPhone?: string
  flatRate?: number
  baseRate?: number
  perKgRate?: number
}

@Injectable({
  providedIn: 'root'
})
export class AymakanSettingsService extends BaseShippingProviderService<AymakanSettings, AymakanSettingsStatus> {
  protected readonly providerKey = 'aymakan'
  protected readonly providerLabel = 'Aymakan'

  protected mapStatus(entry: ProviderStatusEntry): AymakanSettingsStatus {
    return {
      connected: entry.connected,
      enabled: entry.enabled,
      originCountryCode: entry.originAddress?.countryCode,
      originCityName: entry.originAddress?.cityName,
      originAddressLine: entry.originAddress?.addressLine,
      originPhone: entry.originAddress?.phone,
      flatRate: entry.settings?.['flatRate'] as number | undefined,
      baseRate: entry.settings?.['baseRate'] as number | undefined,
      perKgRate: entry.settings?.['perKgRate'] as number | undefined
    }
  }

  protected buildSaveBody(projectId: string, settings: AymakanSettings): Record<string, unknown> {
    return {
      projectId,
      enabled: settings.enabled,
      apiKey: settings.apiKey,
      originCountryCode: settings.originCountryCode,
      originCityName: settings.originCityName,
      originAddressLine: settings.originAddressLine,
      originPhone: settings.originPhone,
      flatRate: settings.flatRate ?? undefined,
      baseRate: settings.baseRate ?? undefined,
      perKgRate: settings.perKgRate ?? undefined,
    }
  }
}
